import { useRoutes } from "react-router";

import MainRoutes from "./MainRoutes";
import UserRoutes from "./UserRoutes";
import WatchRoutes from './WatchRoutes';
import AuthRoutes from './AuthRoutes';

export default function Routes() {
    return useRoutes([MainRoutes, UserRoutes, AuthRoutes]);
}

// changes